<template>
  <div class="layout" id="myComponentDiv">
    <div class="box-titulo">Reporte de Ventas Canastilla</div>
    <div class="box-container">
      <div class="box-filtres">
        <table>
          <tbody>
            <tr>
              <td width="150px">
                <input
                  id="fechainicio"
                  placeholder="Fecha inicio"
                  datatype="fecha"
                  type="text"
                  class="form-control"
                  autocomplete="off"
                  v-on:change="trigger()"
                />
              </td>
              <td width="150px">
                <input
                  id="fechafin"
                  placeholder="Fecha final"
                  datatype="fecha"
                  type="text"
                  class="form-control"
                  autocomplete="off"
                  v-on:change="trigger()"
                />
              </td>
              <td>
                <button
                  class="btn btn-warning"
                  type="submit"
                  v-on:click="getReporteEquipos"
                >
                  Consultar
                </button>
              </td>
              <td>
                <div v-if="loading">
                  <img src="dist/img/kubber-loading.gif" style="width: 30px" />
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div id="containter-table" class="containter-table">
        <table
          id="table1"
          width="100%"
          class="display nowrap"
          style="width: 100%"
        >
          <thead>
            <tr>
              <th v-if="mostrarEDS > 1" width="130px">EDS</th>
              <th width="130px">Fecha</th>
              <th width="30px">Tipo</th>
              <th width="100px">Consecutivos</th>
              <th width="100px">HASH</th>
              <th>Promotor</th>
              <th width="600px">Producto</th>
              <th width="50px">P.cantidad</th>
              <th width="50px">P.precio</th>
              <th width="50px">P.total</th>
              <th width="60px" class="text-center">Impuesto</th>
              <th width="80px" class="text-center">Venta</th>
              <th width="30px" class="text-center">Acciones</th>
            </tr>
          </thead>
        </table>
      </div>
      <div>
        <table width="300px" class="table font-oswald">
          <tbody>
            <tr>
              <td class="subtable" width="150px">TRANSACCIONES</td>
              <td class="subtable b text-right">
                {{ totalventas }}
              </td>
            </tr>
            <tr>
              <td class="subtable">CANTIDAD PRODUCTOS</td>
              <td class="subtable b text-right">
                {{ fcantidad }}
              </td>
            </tr>
            <tr>
              <td class="subtable">TOTAL IMPUESTOS</td>
              <td class="subtable b text-right">
                {{ ftotalimpuestos }}
              </td>
            </tr>
            <tr>
              <td class="subtable">TOTAL VENTAS</td>
              <td class="subtable b text-right">
                {{ ftotales }}
              </td>
            </tr>
            <tr>
              <td class="subtable">FECHA INICIO</td>
              <td class="subtable b text-right">
                {{ fecha_inicio_reporte }}
              </td>
            </tr>
            <tr>
              <td class="subtable">FECHA FINAL</td>
              <td class="subtable b text-right">
                {{ fecha_final_reporte }}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div id="myModal" class="modal" tabindex="-1" role="dialog">
        <div class="modal-dialog" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title">Venta # {{ venta._id }}</h5>
              <button
                type="button"
                class="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body bg-gray">
              <div class="bg-gray">
                <div class="bg-gray">
                  <FacturaPosView :key="facturaKey" :object="factura" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div v-if="!permiso_lista">
        {{ this.person.nombre }}, {{ this.GLOBAL.MENSAJE.SIN_AUTORIZACION }}
      </div>
    </div>
  </div>
</template>

<script>
import GLOBAL from "../../Global.js";
import ReporteService from "../../service/ReporteService";
import FacturaPosView from "../../components/FacturaPosView.vue";

export default {
  data() {
    return {
      GLOBAL,
      table: null,
      reporteService: null,
      person: null,
      mostrarEDS: true,
      permiso_lista: false,
      reporte: [],
      totalventas: 0,
      totaleds: 0,
      totalimpuestos: 0,
      totales: 0,
      ftotalimpuestos: "$ 0",
      ftotales: "$ 0",
      totalCantidad: 0,
      fcantidad: "0",
      venta: [],
      facturaKey: 0,
      factura: [],
      loading: true,
      fecha_inicio_reporte: "",
      fecha_final_reporte: "",
    };
  },
  components: { FacturaPosView },
  created() {
    this.person = JSON.parse(sessionStorage.getItem(GLOBAL.SESSION_KEY));
    this.permiso_lista = this.person.funciones.includes(
      GLOBAL.PERMISOS.REPORTE.HOROMETRO
    );

    this.reporteService = new ReporteService();

    this.factura = {};
    this.factura.empresa = {};
    this.factura.consecutivo = {};
    this.factura.origen = {};
    this.factura.promotor = {};
    this.factura.invoiceTaxExclusiveTotal = 0.0;
  },
  mounted() {
    var fecha = new Date();
    $("#fechainicio").val(
      fecha.getFullYear() +
        "-" +
        (fecha.getMonth() + 1 <= 9
          ? "0" + (fecha.getMonth() + 1)
          : fecha.getMonth() + 1) +
        "-" +
        (fecha.getDate() <= 9 ? "0" + fecha.getDate() : fecha.getDate()) +
        " 00:00"
    );
    $("#fechafin").val(
      fecha.getFullYear() +
        "-" +
        (fecha.getMonth() + 1 <= 9
          ? "0" + (fecha.getMonth() + 1)
          : fecha.getMonth() + 1) +
        "-" +
        (fecha.getDate() <= 9 ? "0" + fecha.getDate() : fecha.getDate()) +
        " 23:59"
    );

    $("input[datatype='fecha']").datetimepicker();
    this.table = $("#containter-table").html();

    this.getReporteEquipos();
  },
  methods: {
    refrescarFactura() {
      this.facturaKey += 1;
    },
    openMe(item) {
      var obj = null;
      for (var i in this.reporte) {
        if (this.reporte[i]._id == item) {
          obj = this.reporte[i];
        }
      }

      this.venta = obj;
      this.reporteService
        .getFactura(this.person, this.venta)
        .then((data) => {
          this.factura = data;
          this.factura.hash = obj.hash;
          this.refrescarFactura();
        })
        .then(() => {
          $("#myModal").modal("show");
        });
    },
    getReporteEquipos() {
      this.reporte = [];

      var fechainicio = $("#fechainicio").val();
      var fechafin = $("#fechafin").val();
      this.loading = true;
      this.reporteService
        .verVentaCanastilla(this.person, fechainicio, fechafin)
        .then((data) => {
          this.totalventas = 0;
          this.totaleds = 0;

          this.totalimpuestos = 0;
          this.totalCantidad = 0;
          this.totales = 0;

          var eds = [];

          var x = 0;
          var facturas = [];
          for (const i in data) {
            eds[data[i].estacion] = 1;

            if (
              typeof facturas[data[i].prefijo + "-" + data[i].consecutivo] ==
              "undefined"
            ) {
              facturas[data[i].prefijo + "-" + data[i].consecutivo] = 1;
              this.totalventas++;
              this.totalimpuestos += data[i].impuesto_total;
              this.totales += data[i].venta_total;
            }

            this.reporte[x] = [];
            this.reporte[x].hash = data[i].hasp;
            this.reporte[x].prefijo = data[i].prefijo;
            this.reporte[x].numero = data[i].consecutivo;

            this.reporte[x].codigo = data[i].codigo;
            this.reporte[x].documento = data[i].documento;

            var fecha = data[i].fecha.split(".")[0].replace("T", " ");

            this.reporte[x].item = x;
            this.reporte[x]._id = data[i]._id;
            this.reporte[x].estacion = data[i].estacion;
            this.reporte[x].consecutivo =
              data[i].prefijo + "-" + data[i].consecutivo;
            this.reporte[x].fecha = fecha;
            this.reporte[x].hash = data[i].hasp;
            this.reporte[x].persona_nombre = data[i].persona_nombre;
            this.reporte[x].cantidad = GLOBAL.FORMATO_NUMBER(data[i].cantidad);
            this.reporte[x].venta_subtotal = GLOBAL.FORMATO_MONEY(
              data[i].venta_subtotal
            );
            this.reporte[x].impuesto_total = GLOBAL.FORMATO_MONEY(
              data[i].impuesto_total
            );

            this.reporte[x].producto_nombre = data[i].producto_nombre;
            this.reporte[x].producto_cantidad = GLOBAL.FORMATO_NUMBER(
              data[i].producto_cantidad
            );
            this.reporte[x].producto_precio = GLOBAL.FORMATO_MONEY(
              data[i].producto_precio
            );
            this.reporte[x].producto_total = GLOBAL.FORMATO_MONEY(
              data[i].producto_total
            );
            this.reporte[x].boton =
              '<button class="btn btn-sm btn-info" data-id="' +
              data[i]._id +
              '" id="edit"><i class="fa-solid fa-receipt"></i></button>';

            x++;
            this.totalCantidad += data[i].producto_cantidad;
          }

          for (const i in eds) {
            this.totaleds++;
          }

          this.fcantidad = GLOBAL.FORMATO_NUMBER(this.totalCantidad);
          this.ftotalimpuestos = GLOBAL.FORMATO_MONEY(this.totalimpuestos);
          this.ftotales = GLOBAL.FORMATO_MONEY(this.totales);
          this.fecha_inicio_reporte = fechainicio;
          this.fecha_final_reporte = fechafin;
        })
        .then(() => {
          //FIX: en este orden soluciona el problema de datatable repetida//
          try {
            $("#table1").DataTable().destroy();
          } catch (error) {}
          $("#containter-table").html(this.table);

          const boxes = document.querySelectorAll(".btt");
          boxes.forEach((box) => {
            box.remove();
          });

          var columnas = [];

          this.mostrarEDS = false;
          columnas = [
            { name: "second", data: "fecha" },
            { data: "codigo" },
            { data: "consecutivo" },
            { data: "hash" },
            { data: "persona_nombre" },

            { data: "producto_nombre" },
            { data: "producto_cantidad" },
            { data: "producto_precio" },
            { data: "producto_total" },

            { data: "impuesto_total", class: "text-right" },
            { data: "venta_subtotal", class: "text-right" },
            {
              data: "boton",
            },
          ];

          //END FIX://

          $("#table1").DataTable({
            data: this.reporte,
            columns: columnas,
            rowsGroup: [0, 1, 2, 3, 4, 9, 10, 11],
            dom:
              "<'btt row'<'col-sm-2'l><'col-sm-4'B><'col-sm-6'f>>" +
              "<'row'<'col-sm-12'tr>>" +
              "<'btt row'<'col-sm-5'i><'col-sm-7'p>>",
            buttons: [
              {
                extend: "copyHtml5",
                text: '<i class="fa-regular fa-clipboard"></i>',
              },
              {
                extend: "excelHtml5",
                text: '<i class="fa-regular fa-file-excel"></i>',
              },
              {
                extend: "csvHtml5",
                text: '<i class="fa-solid fa-file-csv"></i>',
              },
              {
                extend: "pdfHtml5",
                text: '<i class="fa-regular fa-file-pdf"></i>',
              },
            ],
            scrollX: true,
            responsive: false,
            autoWidth: true,
            lengthMenu: [
              [10, 20, 50, -1],
              [10, 20, 50, "Todos"],
            ],
            language: {
              url: "plugins/Spanish.json",
            },
          });
          this.loading = false;
          var vm = this;
          $("#table1 tbody").off("click");
          $("#table1 tbody").on("click", "#edit", vm, function () {
            let id = $(this).data("id");
            vm.openMe(id);
          });
        });
    },

    formatDate(value) {
      return value;
    },
    formatCurrency(value) {
      return value;
    },
  },
};
</script>
